module.exports = __webpack_public_path__ + "img/IAR17.59ddc3d3.png";